import React from 'react';

import { useAppSelector } from 'redux/hooks';
import type { IframePage } from "types/iframe";
import { withParamsFrame } from 'HOCs';

const Products: React.FC<IframePage> = ({ params }) => {
    const [httpParams] = React.useState(params);

    const { accessToken, sellerId } = useAppSelector(({ users, sellers }) => ({
        accessToken: users.currentUser.data.accessToken,
        sellerId: sellers.currentSeller.info.data?.id,
    }))

    return (
        <>
            <div className='xs:mx-3'>
                <iframe className={'page-iframe'} src={`https://lk.market/${sellerId}/pim${httpParams}`}
                    title="Products"
                    width="100%"
                    height={"calc(100vh-64px)"}

                ></iframe>
            </div>
        </>
    );

}
export default withParamsFrame(Products);
